import React from 'react'
import Typewriter from 'typewriter-effect'

import Squares from '../Squares'

export default () => {
    return (
        <div className="lg:p-0 pb-8 relative section hero">
            <div id="home" style={{ transform: 'translateY(-68px)' }} />
            <div className="absolute w-full top-0 right-0 z-0">
                <Squares />
            </div>
            <div className="container z-10 sticky flex flex-col-reverse lg:flex-row align-center justify-between items-center p-4" style={{ minHeight: 'calc(100vh - 68px)' }}>
                <div className="introduction-text mt-8 text-center lg:text-left lg:mt-0 flex-1 text-white">
                    <p className="text-sm lg:text-lg">Hello,</p>
                    <h1 className="font-bold text-xl lg:text-6xl">I am <span className="text-main">Luís Tessaro</span></h1>
                    <h3 className="font-medium text-3xl mb-2">
                        <Typewriter
                            options={{
                                strings: ['Fullstack Developer', 'Backend Developer', 'Frontend Developer', 'Game Developer'],
                                autoStart: true,
                                loop: true,
                            }}
                        />
                    </h3>
                    <h5 className="mb-2 text-sm w-full lg:w-8/12 font-normal leading-loose">React, NodeJS, Express, MongoDB, Vue, SCSS, C/C#/C++, Java, Python, SQL among some other ones that I dont care as much.</h5>
                    <div className="resume w-full lg:w-1/2 mt-10">
                        <a className="btn py-5 px-16 border border-solid border-white rounded font-bold hover:text-gray-900 hover:bg-white transition ease-in duration-150" href="https://drive.google.com/file/d/18sPVREw2_xybrjIylLDtVS0EpyqAinJn/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                            My Resume
                        </a>
                    </div>
                </div>
                <div className="introduction-image" >
                    <img src="https://raw.githubusercontent.com/LuisTessaro/portfolio-react-source/master/public/img/AboutImg.jpg" alt="profile"></img>
                </div>

            </div>
            <div className="flex justify-center items-center w-full">
                <a href="#about" className="hidden z-10 lg:flex flex-col mb-8 text-gray-500 justify-center items-center absolute bottom-0 hover:text-white">
                    <i className="flex justify-center items-center border border-gray-500 hover:border-white rounded-full w-12 h-12 fas fa-chevron-down text-2xl" />
                </a>
            </div>
        </div >
    )
}